














































































import { mapGetters, mapActions } from 'vuex'; 
import { Component, Vue } from 'vue-property-decorator'
const namespace: string = 'oidcStore/';

 @Component({
   computed: {
      ...mapGetters('oidcStore', [
                'oidcIsAuthenticated',
                'oidcUser'
            ])
    },
    methods: {
      ...mapActions('oidcStore', ['authenticateOidcSilent',
                'signOutOidc', 'authenticateOidc'])
    },
})

export default class tool extends Vue{

    drawer:boolean=true
    mini:boolean=true
    userName:string = ''
    item:number=1

         filterMenuItems(role: string) {

            if (this.$store.getters[namespace + 'oidcIsAuthenticated']) {

                return this.items.filter((x: any) => x.roles && x.roles.some((y: any) => y === role))
            }
            return []
        }


         get workerItem() {
            return this.filterMenuItems('Worker')
        }

         get AdministradorItem() {
            return this.filterMenuItems('Administrator')
        }


        hasRole(role: string): boolean {
            const user = this.$store.getters[namespace + 'oidcUser'];
            var roles=user.role;

            if (Array.isArray(roles) ) {
                return roles.some((x:any) => x === role || roles.some((x:any) => x === role))
            }
            else {
                return roles === role;
            }
        }
      

    items:any=[
        { title: 'Customers', icon: "nature_people", path:'/customers', roles:['Administrator']},
        { title: 'Hours', icon: "access_time", path:'/hours', roles:['Administrator']},
        { title: 'Jobs', icon: "developer_board", path:'/kanban', roles:['Worker']},
        { title: 'Users', icon: "build", path:'/users', roles:['Administrator']},
        //{ title: 'Request', icon: "input", path:'/request', roles:['Administrator']},
        { title: 'Report hours', icon: "access_time", path:'/reporthours', roles:['Worker']},
        { title: 'Services', icon: "rv_hookup", path:'/services', roles:['Administrator','Worker']},
    ]
}
